import { render, staticRenderFns } from "./ListFolder.vue?vue&type=template&id=4fab2c8d"
import script from "./ListFolder.vue?vue&type=script&lang=js"
export * from "./ListFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fab2c8d')) {
      api.createRecord('4fab2c8d', component.options)
    } else {
      api.reload('4fab2c8d', component.options)
    }
    module.hot.accept("./ListFolder.vue?vue&type=template&id=4fab2c8d", function () {
      api.rerender('4fab2c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Folder/ListFolder.vue"
export default component.exports